module.exports = __webpack_public_path__ + "static/media/sold-vehicles-pic.cd3f7fdb.png";